import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import DialogModal from "../../common/DialogModal";
import Button from "../../Parts/Button";
import InputComponent from "../../common/InputComponent";
import { validateSender, numHyphen } from "../../../utils/validator";
import { DialogType } from "../../../constants/ComponentTypes";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "0 25px 25px 25px",
    margin: 0,
    textAlign: "left",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    margin: "50px 0",
  },

  fullWidth: {
    width: "100%",
  },

  tooltip: {
    backgroundColor: "#d32f2f",
    width: "100%",
    maxWidth: "335px",
  },

  input: {
    boxSizing: "border-box",
  },
});

export const senderFormProps = [
  { key: "post_code", value: "郵便番号 (任意)", placeholder: "郵便番号を入力" },
  { key: "address", value: "住所 (任意)", placeholder: "住所を入力" },
  { key: "company", value: "会社名 (任意)", placeholder: "会社名を入力" },
  { key: "branch", value: "部署 (任意)", placeholder: "部署を入力" },
  { key: "position", value: "役職 (任意)", placeholder: "役職を入力" },
  { key: "name", value: "名前", placeholder: "名前を入力" },
];

class EditSenderDialog extends React.Component {
  constructor(props) {
    super(props);

    let initialState = {
      post_code: "",
      address: "",
      company: "",
      branch: "",
      position: "",
      name: "",
      error: {},
      saveBtnPressed: false,
    };

    if (props.item) {
      for (let key in initialState) {
        initialState[key] = props.item[key]
          ? props.item[key]
          : initialState[key];
      }
    }

    this.state = { ...initialState };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isSaving &&
      !nextProps.isSaving &&
      nextProps.error === null
    ) {
      nextProps.toggleDialog();
    }

    if (nextProps.error) {
      this.setState({
        error: nextProps.error,
      });
    }
  }

  handleChange = (property) => (event) => {
    let value = event.target.value;

    //２回目からタイピングごとでチェック
    if (this.state.saveBtnPressed) {
      this.validateForm({ ...this.state, [property]: value });
    }

    this.setState({
      [property]: value,
    });
  };

  handleSave = () => {
    let { error, saveBtnPressed, ...data } = this.state;
    if (!saveBtnPressed) error = this.validateForm(data);

    if (Object.keys(error).length === 0) {
      //take out hyphens in postcode,tel,fax
      for (let p in data) {
        if (p === "post_code") {
          data[p] = numHyphen(data[p]);
        }
      }

      if (DialogType && DialogType.EDIT && this.props.item) {
        data["sender_id"] = this.props.item.id;
      }
      this.props.save(data);
    } else {
      this.setState({
        saveBtnPressed: true,
      });
    }
  };

  validateForm = (state = {}) => {
    let error = validateSender(state);

    this.setState({
      error: error,
    });

    return error;
  };

  countErrors = () => {
    return Object.keys(this.state.error).length;
  };

  render() {
    const { classes, toggleDialog, isSaving } = this.props;
    const { error } = this.state;

    return (
      <DialogModal
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={toggleDialog}
        title="差出人を編集"
      >
        <form>
          {senderFormProps.map((prop, i) => (
            <div className={classes.fullWidth} key={i}>
              <InputComponent
                title={prop.value}
                placeholder={prop.placeholder}
                value={this.state[prop.key]}
                onChange={this.handleChange(prop.key)}
                error={error[prop.key] ? error[prop.key] : ""}
              />
            </div>
          ))}
        </form>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.props.toggleDialog}
            size="large"
            type="ghost"
            text="キャンセル"
            style={{ background: "transparant" }}
          ></Button>
          <Button
            handleClickButton={this.handleSave}
            size="large"
            disabled={this.countErrors() !== 0}
            loading={isSaving}
            text="保存"
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

EditSenderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  save: PropTypes.func,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  item: PropTypes.object,
};

export default withStyles(styles)(EditSenderDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/EditSenderDialog.jsx